import { TripBookingTypes } from '../../lib/types/models/trip-booking/trip-booking'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripBookingsDocuments(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripFolder.getTripFolderDocuments.url, { id }))
    .get<TripBookingTypes.Advanced[]>()
}
